import * as tags from "../constants/tags.js";
import {
  ABSTRACTION_STEPS,
  ABSTRACT_REQUEST_STATUSES,
} from "../constants/abstraction-statuses.js";
import { DOES_NOT_EXPIRE } from "../constants/api-token-constants.js";
import { SPECIAL_PROMO_CODES } from "../constants/promotion-constants.js";
import {
  INVITE_ALREADY_ACCEPTED,
  INVITE_COULD_NOT_BE_PROCESSED,
  INVITE_RATE_LIMITED,
  NON_UNIQUE_ENTITY,
  SHARED_ENTITY_NOT_FOUND,
} from "../constants/exceptions.js";
import { CREDIT_ADJUSTMENT_TYPE } from "../constants/transaction-constants.js";

export default {
  back: "Back",

  // Auth
  workspaceNotFound:
    "The workspace you are trying to access does not exist or you do not have permission to access it.",

  // Not Found
  couldNotFindPage: "We couldn't find the page you were looking for.",
  pageNotFound: "404 Page Not Found",
  backToHome: "Back to home",

  // Access Denied
  accessDenied: "Access Denied",
  tryLoggingInAgain: "Please try logging in again to continue.",

  // Login Page
  login: "Log In",
  loginOrSignup: "Log In",
  instantAbstraction: "Instant Abstraction",
  startsHere: "Starts Here",
  forMoreInformation:
    "For more information, please visit <a>prophia.com/instant-lease-abstract</a>",
  continue: "Continue",
  continueWithEmail: "Continue with Email",
  prophiaAbstract: "Prophia Abstract",
  continueWith: "Continue with",
  email: "Email",
  password: "Password",
  showPassword: "Show Password",
  hidePassword: "Hide Password",
  or: "or",
  signUpCTA: "Don't have an account? <a>Sign up for free</a>",
  invalidEmail: "Invalid Email",
  invalidEmailPassword: "Invalid email and/or password",
  forgotPassword: "Forgot Password",
  rememberMe: "Remember Me",
  sessionExpired: "Your session has expired. Please log in again.",
  loginSuccessful: "Login Successful",
  loadingYourAccount: "Loading your account",
  loading: "Loading",
  resultsLoading: "Results Loading",

  // Sign Up Page
  signUp: "Sign Up",
  createANewAccount: "Create a New Account",
  firstName: "First Name",
  lastName: "Last Name",
  firstNamePlaceholder: "First",
  lastNamePlaceholder: "Last",
  chooseAPassword: "Choose a Password",
  confirmPassword: "Confirm Password",
  jobFunction: "Job Function",
  howDidYouHearAboutUs: "How did you hear about us?",
  optional: "Optional",
  termsOfServiceMessage: "I agree to the <a1>Terms of Service</a1>",
  termsOfService: "Terms of Service",
  linkedInReddit: "LinkedIn or Reddit",
  referralWordOfMouth: "Referral or Word of Mouth",
  advisor: "Advisor",
  onlineSearch: "Online Search",
  conferenceEvent: "Conference or Event",
  newsArticle: "News Article",
  other: "Other",
  accountWithEmailAlreadyExists:
    "This email is already associated with another login method. Please choose a different login method or create an account using a different email.",

  // Sunset
  signUpSunsetTitle: "Sign-Up Is No Longer Available",
  signUpSunsetBody:
    "Prophia Abstract is no longer accepting new accounts. If you already have an account, please log in to continue.",
  oauthSignupDisabled:
    "Sign-up is no longer available on Prophia Abstract. If you already have an account, please log in using the same method you signed up with.",

  brokerageLeasing: "Brokerage - Leasing",
  brokerageInvestmentSales: "Brokerage - Investment Sales",
  brokerageDebt: "Brokerage - Debt",
  ownerOperator:
    "Owner/Operator (Property & Asset Management, Equity Investor, etc)",
  dataTechProvider: "Data or Technology Provider",
  advisoryServicesFirm: "Advisory or Services Firm",
  appraisalValuation: "Appraisal/Valuation",
  occupierTenant: "Occupier/Tenant",
  legal: "Legal",
  selectAFunction: "Select a function",

  // Reset Password Page
  resetPassword: "Reset Password",
  enterANewPassword: "Enter a New Password",
  savePassword: "Save Password",
  passwordMustBeNew: "Your password cannot be the same as the last one",
  passwordSuccessfullyReset: "Password successfully reset!",
  gotoLogin: "Go to Login Page",
  emailLinkExpired: "Email verification link has expired",
  willBeRedirected:
    "You'll be automatically redirected in {{seconds}} seconds.",
  clickHere: "Click here",
  ifNotAutomaticallyRedirected: "If you're not redirected automatically.",

  //Forgot Password Page
  resetPasswordText:
    "Enter your email address and we will send you a link to reset your password.",
  enterEmail: "Enter login email address",
  sendEmail: "Send Email",
  passwordLinkSent: "Reset Password Link Sent!",
  resendLink: "Re-send Link",
  resendLinkText:
    "If you dont see an email from us in the next 2 minutes, please try re-sending the link",

  // Select Input
  selectAnOption: "Select an Option",
  expand: "Expand",
  collapse: "Collapse",

  // Text Input
  showText: "Show Text",
  hideText: "Hide Text",

  // Validation
  thisFieldIsRequired: "This field is required",
  passwordsDoNotMatch: "Passwords do not match",
  somethingWentWrong: "Something went wrong",
  somethingWentWrongTryAgain: "Something went wrong, please try again",

  // Nav

  navigation: {
    collapseSidebar: "Collapse sidebar",
    expandSidebar: "Expand sidebar",
  },

  leaveWorkspace: {
    leaveWorkspace: "Leave {{workspaceName}}",
    leaveWorkspaceMessage:
      "Are you sure you want to leave {{workspaceName}}? You will lose access to all abstracts and credits in this workspace.",
    leaveWorkspaceConfirm: "Leave",
  },

  createWorkspaceModal: {
    workspaceName: "Workspace Name",
    createWorkspace: "Create Workspace",
    renameWorkspace: "Rename {{workspaceName}}",
    rename: "Rename",
    workspaceNameAlreadyExists: "A workspace with this name already exists.",
  },
  deleteWorkspace: {
    deleteWorkspace: "Delete {{workspaceName}}",
    deleteWorkspaceMessage:
      "Are you sure you want to delete {{workspaceName}}? Deleted workspaces can be restored within 30 days by contacting support.",
    deleteWorkspaceConfirm: "Delete",
  },

  logout: "Log out",
  youWillBeLoggedOut:
    "You will be logged out of Prophia Abstract. You will need to sign-in again to access your account",
  account: "Account",
  support: "Support",
  home: "Home",
  supportMessage: "Need help or have some feedback?",
  supportLinkMessage:
    "Contact us at <a1>abstract@prophia.com</a1> or <a2>sign up </a2> to talk with us",
  supportCenter: "Support Center",
  emailUs: "Email Us",
  scheduleACall: "Schedule a Call",
  terms: "Terms",
  termGlossary: "Term Glossary",
  createNewTerm: "Create New Term",
  configureAbstractSummaryTerms: "Configure Abstract Terms",
  inviteUsers: "Invite Users",
  invite: "Invite",
  accept: "Accept",
  reject: "Reject",
  emails: "Emails",
  workspaceInviteModalTitle: "Invite users to {{workspaceName}}",
  workspaceInviteModalDescription:
    "Invites expire after 7 days. Invited users will have full access to all content and actions in this workspace except:",
  workspaceInviteModalRestrictionDelete: "Workspace deletion",
  workspaceInviteModalRestrictionInvite: "Inviting other users",
  workspaceInviteMessage: "Type in an email address and hit enter to save it",
  invitesSent: "Workspace invitations have sent",
  newWorkspace: "New Workspace",
  allWorkspaces: "All Workspaces",
  workspaceSettingsDropdown: "Workspace Settings",
  addCredits: "Add Credits",
  workspaces: "Workspaces",
  settings: "Settings",
  leave: "Leave",
  owner: "Owner",
  default: "Default",
  switchWorkspace: "Switch workspace",
  reinvite: "Reinvite",
  remove: "Remove",
  from: "from",
  pendingInvitesCount: "({{count}} Pending)",
  pendingInvitation: "Pending invitation",
  pendingInvitations: "Pending Invitations",
  acceptingInvite: "Accepting Invite",
  inviteAccepted: "You have accepted the invite to this workspace.",
  inviteRejected: "You have rejected this workspace invitation.",
  acceptingWorkspaceInvite:
    "You are being added to the workspace, please wait while we set up your access",

  // User Info Page
  justAFewMoreDetails: "Just a few more details",

  //Home Page
  uploadLimits: "PDF only (max. 30MB)",
  selectAFile: "<a>Select a document</a> or drag and drop",
  selectDocuments: "<a>Select documents</a> or drag and drop",
  abstractDocument: "Abstract Document",
  fileSize: "File Size:",
  pdfDocumentsOnly: "PDF Documents Only",
  uploadAPdf: "Only PDF documents are allowed. Please upload a valid PDF file.",
  fileTooLarge: "File Too Large",
  exceedsFileSizeLimit:
    "The file you are trying to upload exceeds the file size limit of <a>30MB</a>. Please upload a smaller file.",
  tooManyFiles: "Attempting to upload too many files",
  tooManyFilesMessage:
    "You are attempting to upload more than one file. Please upload only one file at a time.",
  fileCannotBeEmpty: "File Cannot Be Empty",
  pleaseUploadNonEmptyFile:
    "Please make ensure you are uploading a valid, non-empty file.",
  createNAbstracts: "Create ({{count}}) Abstracts",
  pendingFilesConfirmCloseDialog:
    "Your documents have not been abstracted! If you leave now, you’ll need to start over. Do you still want to leave?",
  uploadInProgress: "Upload in progress",
  abstractDescriptionTooltipDisabled:
    "Abstraction will be available once all uploads have completed.",
  nSingleDocumentAbstracts: "{{count}} single-document abstracts",
  nMultiDocumentAbstracts: "{{count}} multi-document abstracts",
  oneSingleDocumentAbstract: "1 single-document abstract",
  oneMultiDocumentAbstract: "1 multi-document abstract",
  abstractsBeingProcessed: "Your abstracts are now being processed!",
  trackProgressBelow: "You can track their progress in the table below.",
  uploadAndAbstract: "Upload & Abstract",
  singleDocumentAbstracts: "Single Document Abstracts",
  multiDocumentAbstracts: "Multi Document Abstracts",
  singleDocumentAbstractsDescription:
    "Each document uploaded here will create its own abstract",
  multiDocumentAbstractsDescription:
    "Each abstract group will create a single consolidated abstract",
  individualAbstracts: "Individual Abstracts",
  createGroup: "Create Group",
  createAnotherGroup: "Create another group",
  abstractGroup: "Abstract Group",
  document: "Document",
  documents: "Documents",
  createAbstracts: "Create Abstracts",
  createAbstract: "Create Abstract",
  deleteGroupModalMessage:
    "This group contains {{documentCount}} document(s). Deleting this group will permanently remove all documents within it. Are you sure you want to delete this group?",
  confirmDeletion: "Confirm Deletion",

  // Term Glossary
  termGlossaryExplanation:
    "Build and manage your own term glossary. You'll have the ability to input your own definitions, examples, and keywords and include these terms in your abstracts.",
  searchForTerm: "Search for Term",
  manual: "Manual",
  examples: "Examples",
  keywords: "Keywords",
  customTerms: "Custom Terms",
  noCustomTermsDefined: "No custom terms have been defined yet",
  deleteTermText1:
    "Deleting will remove the term from the glossary permanently. You will no longer be able to use this custom term in future abstracts.",
  deleteTermText2: "Do you want to continue?",

  // Footer
  privacyPolicyFooterMessage:
    "© Prophia, Inc | <a1>Privacy Policy</a1> | <a2>Terms of Service</a2> | <a3>abstract@prophia.com</a3>",
  privacyPolicy: "Privacy Policy",

  // Abstract Configuration
  configureAbstract: "Configure Abstract",
  configureYourAbstract: "Configure Your Abstract",
  whatTermsWouldYouLike: "What terms would you like in your abstract?",
  selectAll: "Select All",
  deselectAll: "Deselect All",
  selectedTermsCountInfo:
    "{{current}} of {{total}} terms have been selected for abstraction",
  configurationTooltipInfo: "Terms cannot be added to an abstract later",

  // Table
  noData: "No data",

  // Abstract List
  noAbstractDataMessage: "Upload a document above to get started!",
  searchForDocumentName: "Search for Document Name",
  noDataMessage: "Upload a document above to get started!",
  searchForAbstract: "Search for Abstract",
  [ABSTRACTION_STEPS.READING_DOCUMENT]: "Reading Document",
  [ABSTRACTION_STEPS.VALIDATING]: "Validating",
  [ABSTRACTION_STEPS.CONSOLIDATING_LEASE]: "Consolidating Lease",
  [ABSTRACTION_STEPS.RETRIEVING_DATA]: "Retrieving Data",
  [ABSTRACTION_STEPS.SPLITTING_DOCUMENT]: "Splitting Document",
  [ABSTRACT_REQUEST_STATUSES.PROCESSING]: "Processing Document",
  [ABSTRACT_REQUEST_STATUSES.COMPLETED]: "Complete",
  [ABSTRACT_REQUEST_STATUSES.FAILED]: "Failed",
  [`${ABSTRACTION_STEPS.READING_DOCUMENT}.abbreviated`]: "Reading",
  [`${ABSTRACTION_STEPS.VALIDATING}.abbreviated`]: "Validating",
  [`${ABSTRACTION_STEPS.CONSOLIDATING_LEASE}.abbreviated`]: "Consolidating",
  [`${ABSTRACTION_STEPS.RETRIEVING_DATA}.abbreviated`]: "Retrieving Data",
  [`${ABSTRACTION_STEPS.SPLITTING_DOCUMENT}.abbreviated`]: "Splitting",
  [`${ABSTRACT_REQUEST_STATUSES.PROCESSING}.abbreviated`]: "Processing",
  [`${ABSTRACT_REQUEST_STATUSES.COMPLETED}.abbreviated`]: "Complete",
  [`${ABSTRACT_REQUEST_STATUSES.FAILED}.abbreviated`]: "Failed",
  allAbstracts: "All Abstracts",
  fileName: "File Name",
  abstract: "Abstract",
  abstractDate: "Abstract Date",
  uploadDate: "Upload Date",
  numberOfPages: "Number of Pages",
  numberOfDocuments: "# of Documents",
  status: "Status",
  downloadDocument: "Download Document",
  downloadDocuments: "Download Documents",
  downloadAbstract: "Download Abstract",
  retryAbstract: "Retry Abstract",
  retry: "Retry",
  delete: "Delete",
  permanentlyDelete: "Permanently Delete",
  deleteAbstract: "Delete Abstract",
  youAreTryingToDeleteThisAbstract:
    'You are trying to delete "{{filename}}". This will permanently delete this abstract, do you wish to continue?',
  downloadSelected: "Download {{count}} Abstracts",
  abstractZipFile: "abstracts.zip",
  abstractName: "Abstract Name",
  somethingWentWrongTryAbstractAgain:
    "Something went wrong. Please try running the abstract again.",
  reUploadOrContactUs:
    "Please try re-uploading the document/s again or contact us at <a>abstract@prophia.com</a",
  clickToRetry: "Click here to retry.",
  retriesRemaining: "{{retriesRemaining}} retries remaning.",

  // password validator
  passwordStrength: "Password Strength",
  requirements: "Requirements",
  itsBetterToHave: "It's better to have",
  atLeast8Chars: "At least 8 characters",
  atLeaseOneNumOrSymbol: "At least one number or symbol",
  atLeaseOneUpperAndLowerCase: "One uppercase & one lowercase letter",
  noNameEmailReference: "No reference to your name or email",
  longerPassword: "At least 12 characters",
  numberAndSymbol: "Number and symbol (e.g. $,#,@,!)",
  average: "average",
  weak: "weak",
  good: "good",
  strong: "strong",
  invalidPassword: "Invalid Password",

  // Account Settings
  accountSettings: "Account Settings",
  updateEmail: "Update Email",
  updatePassword: "Update Password",
  myProfile: "My Profile",
  myAccount: "My Account",
  edit: "Edit",
  deleteAccount: "Delete Account",
  deleteMyAccount: "Delete my account",
  deleteAccountMessage:
    "Permanently delete your user account and all workspaces you own. User and workspace data can only be restored within 30 days of deletion by contacting support.",
  saveChanges: "Save Changes",
  cancel: "Cancel",
  ok: "OK",
  enterCurrentPassword: "Enter Current Password",
  incorrectPassword: "Incorrect Password",
  thirdPartyConnection: "Third-Party Connection",
  searchForDocumentNameOrTransaction: "Search for doc name or transaction id",
  date: "Date",
  description: "Description",
  numberOfCredits: "# of Credits",
  credits: "Credits",
  transaction: "Transaction",
  transactionId: "Transaction ID",
  totalCost: "Total Cost",
  noTransactionDataMessage: "No transaction data found",
  documentAbstract: "Document Abstract",
  refundDocumentAbstract: "Refund - Document Abstract",
  PENDING: "Pending",
  PAID: "Paid",
  CANCELLED: "Cancelled",
  PARTIALLY_REFUNDED: "Partially Refunded",
  ABANDONED: "Abandoned",
  COMPLETELY_REFUNDED: "Refunded",
  REFUNDED: "Refunded",
  refundPending: "Refund Pending",
  refundDenied: "Refund Denied",
  viewReceipt: "View Receipt",
  failedToAbstract: "failed to abstract",
  refundRequest: "Refund Request",
  requestRefund: "Request Refund",
  selectAbstractsForRefund: "Select abstracts for refund",
  selectAbstracts: "Select abstracts",
  selectedAbstracts: "Selected Abstracts",
  reasonForRequest: "Reason for request",
  haveFeedback: "Have feedback for us? Sign up <a>here</a> to talk with us",
  selectAtLeastOneAbstract: "Please select at least one abstract",
  refundRequestSubmitted: "Refund request submitted",
  refundRequestSuccess:
    "Your refund request has been successfully submitted. You will receive a response within the next 3-5 business days. Please check your email for updates on the status of your request.",
  furtherQuestions:
    "If you have any further questions, feel free to contact us.",
  refundRequested: "Refund Requested",
  allAbstractsRemoved: "All abstracts have since been removed or deleted",
  deletedAbstracts: "Deleted Abstracts",
  promoCode: "Promo Code",
  freeAbstracts: "{{number}} Credits",
  buyCredits: "Buy Credits",
  enterYourPromoCode: "Enter your promo code",
  apply: "Apply",
  promoCodeApplied: "Promo code applied!",
  addPromoCode: "Add Promo Code",
  freeAbstract: "{{number}} Credit",

  // Abstract Credits
  creditBundles: {
    singleCreditBundle: "Single credit",
    fivePackCreditBundle: "5 pack credit bundle",
    tenPackCreditBundle: "10 pack credit bundle",
    twentyfivePackCreditBundle: "25 pack credit bundle",
    singleCreditBundleDescription: "Single credit to be used for abstraction",
    fivePackCreditBundleDescription: "5 credits to be used for abstraction",
    tenPackCreditBundleDescription: "10 credits to be used for abstraction",
    twentyfivePackCreditBundleDescription:
      "25 credits to be used for abstraction",
  },
  abstractCredits: {
    saveXPercent: "Save {{save}}%",
    purchaseXCredits: "Purchase {{credits}} Abstract Credits",
    credit: "Credit",
    credits: "Credits",
    abstractCredits: "Abstract Credits",
    manageCredits: "Manage Credits",
    creditsAvailable: "Credits Available",
    creditAvailable: "Credit Available",
    creditsRemaining: "Credits Remaining",
    creditRequired: "Additional Credit Required",
    creditsRequired: "Additional Credits Required",
    autoReload: "Auto-reload",
    purchaseAbstractCredits: "Purchase Abstract Credits",
    chooseTheBundles: "Choose the credit packages that fit your needs!",
    mostPopular: "Most Popular",
    aCoupleNotes: "When purchasing credits, please note",
    creditsMayTakeAMomentToShow:
      "Purchased Credits may take a few moments to appear.",
    oneAbstractPerCredit: "Every Abstract uses 1 Credit",
    successfullyPurchasedCredits: "Credits Purchased successfully!",
    currentCreditBalance: "Current credit balance",
    pendingAbstracts: "Pending abstracts",
    pendingCreditPurchase: "Pending credit purchase",
    totalMissingCredits: "Total missing credits",
    creditsPostAbstraction: "Remaining credit balance",
    newCreditBalance: "New credit balance",
    selected: "Selected",
    errorIncrementingCredits:
      "An error occurred after successfully purchasing your credits.",
    creditsAvailableSoon:
      "The credits should be available momentarily. Contact abstract@prophia.com if issues persist.",
  },
  abstractCreditHistory: {
    creditsPurchased: "Credits Purchased",
    creditsRefunded: "Refund: Credit Purchase",
    abstractCreditHistory: "Abstract Credit History",
    refundExplanation:
      "Fill out the form below in order to request a monetary refund for purchased abstract credits. We will review the request and your abstraction history. Refunds may be issued partially or in full.",
    auto: "Auto",
  },
  autoReload: {
    autoReload: "Auto Reload",
    autoReloadDescription1:
      "When auto reload is enabled, Prophia will automatically reload Abstract Credits into your account when the remaining credits fall below the minimum threshold of 3 Abstract Credits.",
    autoReloadDescription2:
      "Abstract Credits will also be automatically purchased as needed if the number of abstracts in a transaction exceeds the remaining credits in your account. In this case the credits will be purchased repeatedly at the associated bundle price for your configured reload amount until the number of credits needed for the transaction is satisfied. All of this will occur as one combined purchase.",
    byClickingContinue:
      "By clicking Continue you consent to Prophia taking the above actions on your behalf.",
    autoReloadWhenLessThan3: "Auto-reload at less than 3 credits",
    autoReloadBundle: "Auto-reload bundle amount",
    selectABundle: "Select a Credit Bundle",
    autoReloadFailed:
      "The attempt to automatically reload your abstracts failed. Please continue with the normal checkout flow.",
  },
  [CREDIT_ADJUSTMENT_TYPE.PURCHASE]: "Credits Purchased",
  [CREDIT_ADJUSTMENT_TYPE.INITIAL_FREE]: "Signup: Free Abstract",
  [CREDIT_ADJUSTMENT_TYPE.PROMO_CODE]: "Promo Code",
  [CREDIT_ADJUSTMENT_TYPE.REFERRAL_BONUS]: "Referral Bonus",
  [CREDIT_ADJUSTMENT_TYPE.SURVEY_BONUS]: "Survey Response Bonus",
  [CREDIT_ADJUSTMENT_TYPE.MANUAL_ADJUSTMENT]: "Manual Adjustment",
  [CREDIT_ADJUSTMENT_TYPE.FAILED_ABSTRACTION_REFUND]:
    "Refund: Failed Abstracts",

  // Workspace Settings
  name: "Name",
  creditsUsed: "Credits used",
  lastActive: "Last active",
  expired: "Expired",
  pending: "Pending",
  ago: "ago",
  noUsersFound: "No users found",
  users: "Users",
  rename: "Rename",

  workspaceSettings: {
    day: "day",
    days: "days",
  },
  reinviteUsersMessage:
    "Are you sure you want to reinvite {{displayName}}? Invites expire after 7 days.",
  removeWorkspaceUserTitle:
    "Remove {{displayName}} from {{displayWorkspaceName}}",
  removeWorkspaceUserMessage:
    "Are you sure you want to remove {{displayName}} from {{displayWorkspaceName}}? They will lose access to all abstracts and credits.",

  // Notifications
  emailNotifications: "Email Notifications",
  receiveAbstractsCompleteEmail:
    "Receive an email notification when your abstract is ready for viewing",

  // Plans & Pricing
  viewAllPlans: "View all plans",
  pricingAndBilling: "Pricing & Billing",
  loggedIn: "Logged in",
  plansAndPricing: "Plans & Pricing",
  currentPlan: "Current Plan",
  basicPlan: "Basic Plan",
  customPlan: "Custom",
  proPlan: "Pro Plan",
  businessPlan: "Business Plan",
  freeIndividualUserAccount: "Free Individual User Account",
  dollarsPerAbstract: "$20 per abstract",
  unlimitedStorage: "Unlimited Storage",
  abstractableDataPoints: "40+ abstractable data points",
  comingSoon: "Coming Soon",
  perMonth: "per month",
  subjectToChange: "Subject to change",
  current: "Current",
  prophiaAbstractPlans: "Prophia Abstract Plans",
  proPlanDescription:
    "If you are interested or have any questions, please reach out to us at abstract@prophia.com",
  businessPlanDescription:
    "If you are interested or have any questions, please reach out to us at abstract@prophia.com",
  customSSO: "Custom SSO",
  apiAccess: "API Access",
  custom: "Custom",
  configurable: "Configurable",
  standard: "Standard",
  abstractSummaryView: "Abstract Summary View",
  multiDocumentAbstract: "Multi-Document Abstract",
  aiDocumentQA: "AI Document Q&A",
  excelExport: "Excel Export",
  advanced: "Advanced",
  numberOfDataPoints: "# of Standardized Terms",
  createCustomTerms: "Create Custom Terms",
  unlimited: "Unlimited",
  storage: "Storage",
  contactUs: "Contact Us",
  tenUsers: "10 Users",
  oneUser: "1 User",
  numberOfUsers: "# of Users",
  basicPriceShortDescription: "$20/per abstract",
  proPriceShortDescription: "Includes 20 abstracts",
  businessPriceShortDescription: "Includes 50 abstracts",

  // Delete Account
  doYouWantToPermanentlyDelete:
    "Do you want to permanently delete your account?",
  youWillDeleteEverything:
    "You will delete all of the workspaces, abstracts, and documents associated with this account. You will no longer have access to any data associated with this account. Data can only be restored within 30 days of deletion by contacting support.",
  reasonForDeletion: "Reason for Deletion",
  reason: "Reason",
  selectAReason: "Select a reason",
  noLongerUsingService: "No longer using the service",
  foundADifferentSolution: "Found a different solution",
  costConcerns: "Cost concerns",
  missingDataPoints: "Missing data points",
  missingProductFeatures: "Missing product features",
  technicalIssuesAndBugs: "Technical issues and bugs",
  securityOrPrivacyConcerns: "Security or privacy concerns",
  companyOrRoleChange: "Company or role change",
  permanentlyDeleteAccount: "Permanently Delete Account",
  letUsKnowYourReason: "Let us know your reason here",

  // Account Deleted Page
  yourAccountHasBeenDeleted: "Your account has been deleted.",
  thankYouForBeingAProphiaUser:
    "Thank you for being a Prophia user since {{signupDate}}.",
  weAreSorryToSeeYouGo: "We're sorry to see you go.",
  signUpForAnotherAccount:
    "If you'd like to try us again, just sign up for a new account.",
  goToHomepage: "Go to homepage",

  // Shared Entity Not Found
  sharedEntityNotFound: {
    title: "We couldn't find that {{entityName}}",
    subtitle: "It may have been deleted or you may not have access to it.",
    abstract: "abstract",
  },

  // Abstract Summary
  aiSummary: "Originally summarized by Prophia AI",
  abstractSummary: "Abstract Summary",
  abstractedOn: "Abstracted on",
  transactionDetails: "Transaction Details",
  buildingDetails: "Building Details",
  commercialTerms: "Commercial Terms",
  rightsAndOptions: "Rights and Options",
  noneFound: "None Found",
  pageNumber: "Page {{pageNumber}}",
  numberOfTerms: "# of Terms Selected",
  numberOfDocumentsAbstracted: "# of Documents Abstracted",
  viewDocumentTimeline: "View Document Timeline and Summary",
  documentName: "Document Name",
  documentTimeline: "Document Timeline",
  showOneMoreReference: "Show 1 more reference",
  showMoreReferences: "Show {{count}} more references",
  mostUpToDate: "Most up-to-date",
  consolidatedAbstract: "Consolidated Abstract",
  reset: "Reset",
  save: "Save",
  edited: "Edited",
  deletedByUser: "Deleted by user",
  insertRow: "Insert Row",
  alreadyExists: "Already exists",
  unsavedChanges: "Unsaved Changes",
  unsavedChangesMessage:
    "It looks like you’ve made some edits that haven’t been saved yet. If you continue without saving, those changes will be permanently lost. Would you like to save before exiting?",
  resetTagMessage:
    "Resetting this value will restore the initial captured value. This will remove any prior changes you may have made. Do you want to continue?",
  deleteValueAndPageReference: "Delete Value and Page Reference",
  deleteValueAndPageReferenceMessage:
    "Deleting will remove the current value and page reference. This is not a permanent delete. But you will still be able to edit or reset the value afterwards. Do you want to continue?",
  permanentlyDeleteValueAndPageReference:
    "Permanently Delete Value and Page Reference",
  permanentlyDeleteValueAndPageReferenceMessage:
    "Permanently deleting will remove the current value and page reference. This action cannot be undone. Do you want to continue?",
  keepEditing: "Keep Editing",
  discardChanges: "Discard Changes",
  saveAndExit: "Save and Exit",
  download: "Download",
  viewDocuments: "View Document(s)",
  allDocuments: "All Documents",
  pdfExport: "PDF Export",
  share: "Share",
  shareAbstractSummary: "Share Abstract Summary",
  viewOnlyLink: "View only link",
  expiresIn: "Expires in",
  expiresOn: "Expires on",
  [DOES_NOT_EXPIRE]: "Does not expire",
  day: "Day",
  days: "Days",
  shareAbstractInfoText:
    "Recipients will only be able to view the abstract and documents. They will not be able to download the abstract or documents.",
  notApplicable: "N/A",
  linkExpiresOn: "Link expires on",
  copy: "Copy",
  copied: "Copied",
  couldNotOcrImage: "Could not retrieve text from annotation",
  enterValueHere: "Enter value here",
  showXMore: "Show {{count}} more",
  viewXSubTerms: "View all {{count}} sub-terms",
  collapseSubTerms: "Collapse sub-terms",
  showLess: "Show less",

  manualTags: {
    addNewTerm: "Add New Term",
    termName: "Term Name",
    myTermName: "My Term Name",
  },

  // Referral Links
  referAFriend: "Refer a friend",
  uniqueReferralLink: "Unique referral link",
  inviteViaEmail: "Invite via email",
  inviteFriends:
    "Invite any friends, colleagues, or anyone you think would benefit from this tool.",
  receiveAbstracts:
    "You will receive <a>{{count}} free abstracts</a> for every person that signs up using your link and completes their first abstract!",
  sendInvites: "Send Invites",
  successfullySentReferralInvites: "Your invites were sent successfully!",
  alreadyInvited: "Already invited today",
  duplicateInvite: "Duplicate",
  maxDailyInviteLimitReached: "Daily referral limit reached",

  // Promotions
  [SPECIAL_PROMO_CODES.USER_REFERRAL]: "Refer a friend",

  // Custom Terms
  createNewTermSubtext:
    "AI-generated term creation. Enter in the name of your term and we'll do the rest!",
  enterManually: "Enter manually",
  generate: "Generate",
  termName: "Term Name",
  termNameError: "A term with that name already exists",
  definition: "Definition",
  reviewTermDefinition: "Review Term Definition",
  reviewTerm: "Review Term",
  reviewTermSubtext:
    "The more information provided below, the more accurate your new term will be in your abstracts.",
  examplesMessage:
    "Add or remove text examples for your term. Providing exact text examples from leases will help us provide the best accuracy for your abstracts.",
  regenerateAllExamplesAndKeywords: "Regenerate all examples and keywords",
  keywordsMessage:
    "Add or remove keywords for your term. Keywords can be terms or phrases that are related to your term. Type in your keyword and hit enter to save it.",
  addAnExample: "Add an Example",
  generatingTerm: "Generating Term",
  unsavedTerm: "Unsaved Term",
  unsavedTermMessage: "If you exit without saving, all changes will be lost.",
  areYouSureYouWantToContinue: "Are you sure you want to continue?",
  exitWithoutSaveing: "Exit Without Saving",
  createTerm: "Create Term",
  regenerateDetailsInfo:
    "This will regenerate the examples and keywords based on the term name and definition",
  generatingANewExample: "Generating a new example",
  editTerm: "Edit Term",
  manageCustomTerms: "Manage Custom Terms",
  AtoZ: "A to Z",
  ZtoA: "Z to A",
  sortBy: "Sort by",
  newTermSuccessfullyCreated: "New term successfully created!",
  termSuccessfullyUpdated: "Term successfully updated!",

  // Error Boundary
  oopsAnErrorOccurred: "Oops! An unexpected error occurred.",
  ifThisErrorPersists:
    "If this error persists please contact abstract@prophia.com",

  // Errors
  ["Entity not found"]: "We were not able to fetch the requested resource",
  [SHARED_ENTITY_NOT_FOUND]:
    "We were not able to fetch the requested resource. It may have been deleted or you may not have access to it.",
  [NON_UNIQUE_ENTITY]: "That entity already exists",
  ["This invitation was sent to a different email address"]:
    "This invitation was sent to a different email address",
  ["This invitation has expired. Please request a new one"]:
    "This invitation has expired. Please request a new one",
  promoAlreadyUsed: "Promo code was already used",
  invalidPromo: "Invalid promo code",
  ["Not enough credits available"]:
    "There were not enough credits to complete the purchase, please try again!",
  workspaceNameRequired: "Workspace name is required",
  workspaceNameInvalidCharacters:
    "Workspace name must have a length between {{min}} and {{max}} characters and may only contain letters, numbers, spaces, and the following special characters: -_()[]",
  [INVITE_ALREADY_ACCEPTED]: "This invite has already been accepted",
  [INVITE_COULD_NOT_BE_PROCESSED]:
    "Something went wrong and this invite could not be processed, please try again",
  [INVITE_RATE_LIMITED]:
    "This email has been invited recently. Please wait 24 hours to resend",

  // Email Verification
  registrationComplete: "Almost Done!",
  registrationCompleteSubtitle:
    "A verification email has been sent to {{email}}.",
  registrationCompleteTimeout: "You will have 10 minutes to verify your email",
  sendLinkAgain: "Send link again",
  emailSentSuccessfully: "Email sent successfully",
  emailVerified: "Email Verified",
  youHaveSuccessfullyVerifiedYourEmail:
    "You have successfully verified your email. You will be automatically redirected to the login page in {{seconds}} seconds.",
  goToLoginPage: "Go to Login Page",
  emailVerificationFailed: "Email Verification Failed",
  verifyingYourEmail: "Verifying your email",
  emailVerificationFailedSubtitle:
    "The verification link is no longer valid. Please try logging into your account or resetting your password.",
  pageAbbreviation: "Pg",
  page: "Page",
  invalidCharacter: "Contains invalid character",
  onlyOneHistoricalAnnotationAllowed:
    "Only one annotation is allowed per historical entry.",

  //Job Dashboard
  jobDashboard: "Job Dashboard",
  summary: "Summary",
  jobStatusActive: "Active",
  jobStatusCompleted: "Completed",
  jobStatusPending: "Pending",
  jobStatusFailed: "Failed",
  jobStatusWaiting: "Waiting",
  jobStatusCancelled: "Cancelled",
  scheduledJobs: "Scheduled Jobs",
  queues: "Queues",
  queue: "Queue",
  job: "Job",
  triggerNow: "Trigger Now",
  triggering: "Triggering...",

  //Job Detail
  jobId: "ID",
  jobName: "Name",
  jobStatus: "Status",
  jobPriority: "Priority",
  jobAttemptsMade: "Attempts Made",
  jobAttemptsStarted: "Attempts Started",
  jobMaxAttempts: "Max Attempts",
  jobCreated: "Created",
  jobProcessed: "Processed",
  jobFinished: "Finished",
  jobReturnValue: "Return Value",
  jobStackTrace: "Stack Trace",
  jobOptions: "Options",
  latestFailure: "Latest Failed Job",
  jobData: "Job Data",
  jobErrorReason: "Error Reason",
  jobErrorStacktrace: "Stacktrace",

  // Tags
  [tags.TRANSACTION_TYPE]: "Document Type",
  [tags.TENANT_LEGAL_NAME]: "Tenant Legal Name",
  [tags.LANDLORD_LEGAL_NAME]: "Landlord Legal Name",
  [tags.LANDLORD_BROKER]: "Landlord Broker",
  [tags.TENANT_BROKER]: "Tenant Broker",
  [tags.BUILDING_ADDRESS]: "Building Address",
  [tags.RENTABLE_SQUARE_FOOTAGE]: "Rentable Square Footage",
  [tags.SUITE_NUMBERS]: "Suite Numbers",
  [tags.EFFECTIVE_DATE]: "Effective Date",
  [tags.COMMENCEMENT_DATE]: "Commencement Date",
  [tags.TERM]: "Term",
  [tags.EXPIRATION_DATE]: "Expiration Date",
  [tags.TENANT_IMPROVEMENT]: "Tenant Improvement",
  [tags.RENT_ABATEMENT]: "Rent Abatement",
  [tags.BASE_RENT_SCHEDULE]: "Base Rent Schedule",
  [tags.SECURITY_DEPOSITY_AMOUNT]: "Security Deposit",
  [tags.LETTER_OF_CREDIT_AMOUNT]: "Letter of Credit",
  [tags.RENEWAL_OPTION]: "Renewal Option",
  [tags.EARLY_TERMINATION]: "Early Termination",
  [tags.RIGHT_TO_SUBLET]: "Right to Sublet",
  [tags.RENT_COMMENCEMENT_DATE]: "Rent Commencement Date",
  [tags.TAX_ABATEMENT]: "Tax Abatement",
  [tags.PERCENT_RENT]: "Percentage Rent",
  [tags.LATE_FEE]: "Late Fee",
  [tags.PRO_RATA_SHARE]: "Pro Rata Share",
  [tags.OPEX_PRO_RATA_SHARE]: "Opex Pro Rata Share",
  [tags.TAX_PRO_RATA_SHARE]: "Tax Pro Rata Share",
  [tags.RIGHT_OF_FIRST_OFFER]: "Right of First Offer",
  [tags.RIGHT_OF_FIRST_REFUSAL]: "Right of First Refusal",
  [tags.PARKING]: "Parking",
  [tags.LANDLORD_RELOCATION]: "Landlord Relocation",
  [tags.EXPANSION]: "Expansion",
  [tags.EXCLUSIVE_USE]: "Exclusive Use",
  [tags.PURCHASE_RIGHT]: "Purchase Right",
  [tags.ESTOPPEL]: "Estoppel",
  [tags.LANDLORD_TERMINATION]: "Landlord Termination",
  [tags.CONTRACTION]: "Contraction",
  [tags.PERMITTED_USE]: "Permitted Use",
  [tags.PROHIBITED_USE]: "Prohibited Use",
  [tags.GUARANTOR]: "Guarantor",
  [tags.SIGNAGE]: "Signage",
  [tags.TELECOM]: "Telecom",
  [tags.RENTAL_RATE]: "Rental Rate",
  [tags.ACCEPTANCE_PERIOD]: "Acceptance Period",
  [tags.RENEWAL_PERIOD]: "Renewal Period",
  [tags.ADVANCED_NOTICE_PERIOD]: "Advanced Notice Period",
  [tags.NUMBER_OF_ADDITIONAL_PERIODS]: "Number of Additional Periods",
  [tags.EXPANSION_SPACE]: "Expansion Space",
  [tags.RENEWAL_PERIOD_TERM]: "Renewal Period Term",
  [tags.RIGHT_IS_DECLINED]: "Right is Declined",
  [tags.REFUSAL_SPACE]: "Refusal Space",
  [tags.CONTRACTION_SPACE]: "Contraction Space",
  [tags.OFFERED_SPACE]: "Offered Space",
  [tags.CONTRACTION_FEE]: "Contraction Fee",
  [tags.EFFECTIVE_DATE_OF_RIGHT]: "Effective Date of Right",
  [tags.EXPIRATION_DATE_OF_RIGHT]: "Expiration Date of Right",
  [tags.EARLY_MOVE_OUT_DATE]: "Early Move Out Date",
  [tags.OPTION_END_DATE]: "Option End Date",
  [tags.TERMINATION_FEE]: "Termination Fee",
  [tags.TI_AMOUNT]: "TI Amount",
  [tags.TI_REMAINING]: "TI Remaining",
  [tags.TI_SUNSET]: "TI Sunset",
  [tags.ONETIME_ONGOING]: "One time or Ongoing",

  // Abstract Viewer
  bookmarks: "Bookmarks",
  highlights: "Highlights",
  pg: "Pg",
  zoom: "Zoom",
  ZOOM_TO_FIT: "Zoom to Fit",
  findInDocument: "Find in Document",

  // Switch Button
  on: "On",
  off: "Off",

  // Under Construction
  plannedMaintenance: "Scheduled Maintenance in Progress",
  checkBackSoon:
    "We are currently undergoing scheduled maintenance. We apologize for the temporary inconvenience and appreciate your patience!",
  estimatedDowntime: "Estimated downtime: ~ {{timeRemaining}} ({{endTime}})",

  //Excel Export
  documentSummarySheetName: "Document Summary",
  leaseAbstractSheetName: "Lease Abstract",

  docNumber: "Doc #",
  documentType: "Document Type",
  effectiveDate: "Effective Date",
  capturedTerms: "Captured Terms",
  summaryOfChanges: "Summary of Changes",
  reference: "Reference",
  refNumber: "Ref #",
  value: "Value",
  subTermValue: "Sub Term Value",
  generatedByProphia: "Generated by Prophia using AI",
  visitProphia: "Visit Prophia Abstract to generate your own abstract",
  requestJobId: "Job ID",
  reportRunOn: "Report Run On",
  referenceSummary: "Reference Summary",

  //File Splitting
  weSplitTheFile: "We've split your file!",
  containedMultipleDocuments:
    "This file appeared to contain multiple documents. We split them up for you.",
  numberOfDocumentsCreated: "# of Documents Created",

  // Dismissable Modal
  doNotShowAgain: "Don't show me this again",

  //REST Errors
  missingAbstracts: "Must include at least one abstract group.",
  invalidAbstractsFormat: "Abstract groups format is invalid.",
  missingDocuments:
    "Each abstract grouping must contain at least one document.",
  missingFileInfo: "Each document must have a filename and a URL.",
};
